import { useEffect, useRef } from 'react';

export const useClickOutside = (ref, callback = () => {}, ignoreRef = null) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleClickOutside = event => {
      const t = event.target;
      const el = t instanceof Element ? t : t?.parentElement;
      const ignoreContainer = el?.closest('[data-click-outside-ignore]');
      if (!ref.current) return;
      // The ignore marker protects listeners whose ref lives outside it (e.g. a portaled
      // popup being mistaken for an outside click by an unrelated ancestor listener). When
      // ref itself lives inside the ignored container, the marker shouldn't suppress it.
      if (ignoreContainer && !ignoreContainer.contains(ref.current)) return;
      if (ref.current.contains(event.target)) return;
      if (ignoreRef?.current && ignoreRef.current.contains(event.target)) return;
      callbackRef.current();
    };

    // Use capture phase so we receive the event before any child stopPropagation()
    // (e.g. in Accordion or other wrappers) can prevent it from reaching document.
    document.addEventListener('mousedown', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [ref, ignoreRef]);
};
